"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
console.log("custom menu drawer");
var CustommenuDrawer = /*#__PURE__*/function (_HTMLElement) {
  _inherits(CustommenuDrawer, _HTMLElement);
  function CustommenuDrawer() {
    var _this;
    _classCallCheck(this, CustommenuDrawer);
    _this = _callSuper(this, CustommenuDrawer);
    _this.delay = 300;
    return _this;
  }
  _createClass(CustommenuDrawer, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      this.openButton = document.querySelector(".custom-header-hamburger");
      this.menuDrawer = this.querySelector(".custom-menu-drawer");
      this.closeButton = this.querySelector(".close");
      this.backButton = this.querySelector(".back");
      this.secondaryNav = this.querySelector(".secondary-navigation");
      this.secondaryNavList = this.querySelectorAll(".secondary-nav-item");
      this.overlay = this.querySelector(".custom-menu-drawer-overlay");
      this.closeButton.addEventListener("click", this.handleClose.bind(this));
      this.overlay.addEventListener("click", this.handleClose.bind(this));
      this.mainNavList = this.querySelectorAll(".main-nav-item.has-children");
      this.allMainNavList = this.querySelectorAll(".main-nav-item");
      this.mainNavList.forEach(function (e) {
        e.addEventListener("click", _this2.openSubMenu.bind(_this2));
      });
      this.backButton.addEventListener("click", this.backMainMenu.bind(this));
      this.openButton.addEventListener("click", this.handleOpen.bind(this));
    }
  }, {
    key: "openPopupPage",
    value: function openPopupPage(e) {
      var handle = e.target.closest(".secondary-nav-item").dataset.handle;
      var popup = document.getElementById("popup-page-".concat(handle));
      popup.show();
    }
  }, {
    key: "openSubMenu",
    value: function openSubMenu(e) {
      this.menuDrawer.classList.add("submenu-active");
      var nav = e.target.closest(".main-nav-item");
      var handle = nav.dataset.handle;
      this.secondaryNav.classList.add("hidden");
      this.allMainNavList.forEach(function (e) {
        if (e.dataset.handle !== handle) {
          var _e$querySelector;
          e.classList.add("hidden");
          e.classList.remove("active-show");
          (_e$querySelector = e.querySelector(".main-nav-submenu")) === null || _e$querySelector === void 0 || _e$querySelector.classList.remove("show");
        } else {
          var _e$querySelector2;
          e.classList.remove("hidden");
          e.classList.add("active-show");
          (_e$querySelector2 = e.querySelector(".main-nav-submenu")) === null || _e$querySelector2 === void 0 || _e$querySelector2.classList.add("show");
        }
      });
    }
  }, {
    key: "backMainMenu",
    value: function backMainMenu() {
      this.menuDrawer.classList.remove("submenu-active");
      this.allMainNavList.forEach(function (e) {
        var _e$querySelector3;
        (_e$querySelector3 = e.querySelector(".main-nav-submenu")) === null || _e$querySelector3 === void 0 || _e$querySelector3.classList.remove("show");
        e.classList.remove("hidden");
      });
      this.secondaryNav.classList.remove("hidden");
    }
  }, {
    key: "handleOpen",
    value: function handleOpen() {
      var _this3 = this;
      document.querySelector(".shopify-section-header-sticky").style.zIndex = 30;
      document.body.classList.add("overflow-hidden");
      this.classList.add("active");
      this.menuDrawer.style.transform = "translateX(-120%)";
      var transitionend = function transitionend() {
        _this3.menuDrawer.removeEventListener("transitionend", transitionend);
        _this3.menuDrawer.style.transform = "translateX(0)";
      };
      this.menuDrawer.addEventListener("transitionend", transitionend);
      setTimeout(function () {
        _this3.menuDrawer.style.transform = "translateX(0)";
      }, 0);
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      var _this4 = this;
      this.menuDrawer.style.transform = "translateX(-120%)";
      var transitionend = function transitionend() {
        _this4.menuDrawer.removeEventListener("transitionend", transitionend);
        _this4.classList.remove("active");
        document.body.classList.remove("overflow-hidden");
        document.querySelector(".shopify-section-header-sticky").style.zIndex = 3;
      };
      this.menuDrawer.addEventListener("transitionend", transitionend);
    }
  }]);
  return CustommenuDrawer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get("custom-menu-drawer")) {
  customElements.define("custom-menu-drawer", CustommenuDrawer);
}